import { render, staticRenderFns } from "./Prd_proplib.vue?vue&type=template&id=af05f5d6&scoped=true"
import script from "./Prd_proplib.vue?vue&type=script&lang=js"
export * from "./Prd_proplib.vue?vue&type=script&lang=js"
import style0 from "./Prd_proplib.vue?vue&type=style&index=0&id=af05f5d6&prod&lang=scss&scoped=true"
import style1 from "./Prd_proplib.vue?vue&type=style&index=1&id=af05f5d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af05f5d6",
  null
  
)

export default component.exports